import { statusMeta, loadMeta } from "@/lib/format";

export function StatusPill({ level, size = "sm" }) {
  const m = statusMeta(level);
  const Icon = m.icon;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      title={m.full}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${pad} ${m.bg} ${m.text} ${m.border}`}
      data-testid={`status-pill-${level}`}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span aria-hidden="true" className="font-mono">{m.symbol}</span>
      <span>{m.label}</span>
    </span>
  );
}

export function LoadBadge({ cls }) {
  const m = loadMeta(cls);
  const Icon = m.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium ${m.bg} ${m.text} ${m.border}`}
      data-testid={`load-badge-${cls}`}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {m.label}
    </span>
  );
}
